// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { useForm, Controller } from "react-hook-form";
import { IMaskInput } from "react-imask";
import { yupResolver } from "@hookform/resolvers/yup";
import ConfirmationPopUp from "../../components/lk/ConfirmationPopUp";
import EmailIsBusy from "../../components/lk/EmailIsBusy";
import { useStores } from "hooks/useStores";
import { registerSchema } from "./Schema";
import Seo from '../../components/Seo';


const LKReg = () => {
  const [isEmailBusy, setIsEmailBusy] = useState(false);
  const { modalStore, api } = useStores();

  const lkLoginModal = function () {
      modalStore.open('login');
  };

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(registerSchema),
  });

  const confirmationPopUp = () => {
    document.querySelector("#confirmationPopUp").style.display = "flex";
  };

  const emailIsBusy = () => {
    setIsEmailBusy(true);
  };

  const [response, setResponse] = useState("");
  const [email, setEmail] = useState("");

  const onSubmit = (data) => {
    console.log("SUBMIT", { data });
    setEmail(data.email);
    api.auth.postRegistration(data).then((response) => {
      console.log("set")
      setResponse(response);
    });
  };

	const mounted = useRef(true);
	useEffect(() => {
		if (mounted.current) {
			// do componentDidMount logic
			mounted.current = false;
		} else {
			// do componentDidUpdate logic
      if (response?.message === "подтвердите почту") {
        api.user.postConfirm({
          email: email,
        });
        confirmationPopUp();
			} else {
				emailIsBusy();
			}
		}
	}, [response]);

  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const [passwordShown2, setPasswordShown2] = useState(false);
  const togglePasswordVisiblity2 = () => {
    setPasswordShown2(passwordShown2 ? false : true);
  };

  const [agreement, setAgreement] = useState("");

  useEffect(() => {
    api.content.getPageApi("glavnaya")
    .then((res) => {
      setAgreement(res.init_state.agreement);
    });
  }, []);

  const [context, setContext] = useState({});
  useEffect(() => {
      api.content.getPageApi('lk-reg')
      .then((response) => {
        setContext(response.init_state.object);
      })
  }, []);

  return (
    <main>
      <section className='lk-reg'>
        <div className='lk-wrap'>
          <Seo seo={context} />
          <h1 className='lk-reg-title'>Регистрация</h1>

          <form className='lk-reg-form' onSubmit={handleSubmit(onSubmit)}>
            <div className='lk-reg-form-item'>
              <label htmlFor='name'>
                Имя<span className='lk-reg-form__span'>*</span>
              </label>

              <input
                {...register("name")}
                id='name'
                name='name'
                type='text'
                className='lk-reg-input'
                maxLength='50'
              />
              <p className='lk-reg-form__err'>{errors.name?.message}</p>
            </div>
            <div className='lk-reg-form-item'>
              <label htmlFor='company'>Компания</label>
              <input
                {...register("company")}
                id='company'
                name='company'
                type='text'
                className='lk-reg-input'
                maxLength='50'
              />
            </div>
            <div className='lk-reg-form-item'>
              <label htmlFor='email'>
                Email<span className='lk-reg-form__span'>*</span>
              </label>
              <input
                {...register("email")}
                id='email'
                name='email'
                type='email'
                className='lk-reg-input'
                maxLength='50'
              />
              <p className='lk-reg-form__err'>{errors.email?.message}</p>
            </div>
            <div className='lk-reg-form-item'>
              <label htmlFor='password'>
                Пароль<span className='lk-reg-form__span'>*</span>
              </label>
              <input
                {...register("password")}
                id='password'
                name='password'
                type={passwordShown ? "text" : "password"}
                className='lk-reg-input'
                maxLength='50'
              />
              <div
                className='lk-showHide-pass'
                onClick={togglePasswordVisiblity}
              >
                {passwordShown ? <>скрыть</> : <>показать</>}
              </div>
              <p className='lk-reg-form__err'>{errors.password?.message}</p>
            </div>
            <div className='lk-reg-form-item'>
              <label htmlFor='password2'>
                Повторите пароль<span className='lk-reg-form__span'>*</span>
              </label>
              <input
                {...register("password2")}
                id='password2'
                name='password2'
                type={passwordShown2 ? "text" : "password"}
                className='lk-reg-input'
                maxLength='50'
              />
              <div
                className='lk-showHide-pass'
                onClick={togglePasswordVisiblity2}
              >
                {passwordShown2 ? <>скрыть</> : <>показать</>}
              </div>
              <p className='lk-reg-form__err'>{errors.password2?.message}</p>
            </div>
            <div className='lk-reg-form-btn-wrapper'>
              <button className='lk-reg-form-btn' type='submit'>
                Зарегистрироваться
              </button>
              <div className='lk-reg-form-item lk-reg-form-item_position lk-reg-form-item-text'>
                Создавая личный кабинет, я соглашаюсь c{" "}
                <a href={agreement} target='_blank' rel="noreferrer">
                  Условиями обработки персональных данных
                </a>
              </div>
            </div>
          </form>
          <div className='lk-reg-form-item'>
            <button
              id='lk-reg-login-btn'
              className='lk-reg-form-item-account'
              onClick={lkLoginModal}
              type='button'
            >
              Уже есть аккаунт?
            </button>
          </div>
          <ConfirmationPopUp email={email}/>
          {isEmailBusy && (
            <EmailIsBusy
              setIsEmailBusy={setIsEmailBusy}
            />
          )}
        </div>
      </section>
    </main>
  );
};

export default LKReg;
